export interface ISchoolHeaderProps {
  onClick?: () => void
  color?: string
}

export enum EColorBg {
  gold = 'orange5',
  blue = 'white9',
  lime = 'green5',
  rose = 'pink5',
  plum = 'white9',
}

export enum EColorLogo {
  gold = 'coffee',
  blue = 'white',
  lime = 'pine',
  rose = 'maroon',
  plum = 'white',
}

export enum EButtonColor {
  gold = 'orange',
  blue = 'gold',
  lime = 'orange',
  rose = 'gold',
  plum = 'gold',
}
